import { render, staticRenderFns } from "./EventListItem.vue?vue&type=template&id=3b2bd2c2&scoped=true&"
import script from "./EventListItem.vue?vue&type=script&lang=js&"
export * from "./EventListItem.vue?vue&type=script&lang=js&"
import style0 from "./EventListItem.vue?vue&type=style&index=0&id=3b2bd2c2&prod&lang=scss&scoped=true&"
import style1 from "./EventListItem.vue?vue&type=style&index=1&id=3b2bd2c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2bd2c2",
  null
  
)

export default component.exports